<template>
  <div
    class="_content-editor"
    :class="{'editor-error' : hasError}"
  >
    <div class="pl-2 pb-3 d-flex justify-space-between align-center">
      <span class="d-block editor-label">{{ label }}</span>
      <v-btn
        text
        small
        @click="rerender"
        :loading="rerendering"
        class="text-capitalize"
      >
        <v-icon
          small
          dark
        >mdi-refresh</v-icon> Refresh
      </v-btn>
    </div>
    <editor
      api-key="owh5wfefwxc6ww1ieij5ne4rtzan6ycdfjtvpjhap6zv86zs"
      :init="editorConfig"
      v-bind="attributes"
      v-on="listeners"
    />
    <p
      class="error-message"
      v-show="hasError"
    >{{ errorMessage }}</p>
  </div>
</template>
<script>
import head from 'lodash/head'
import isArray from 'lodash/isArray'
import editorConfig from '@/utils/articles/normal-editor-config'

export default {
  props: {
    errorMessages: {
      type: [String, Array],
      default () {
        return null
      }
    },
    label: {
      type: String,
      default: 'Content'
    },
    editorHeight: {
      type: String,
      default: '500'
    }
  },
  data () {
    return {
      editorConfig,
      rerendering: false
    }
  },
  computed: {
    attributes () {
      return {
        ...this.$attrs
      }
    },
    listeners () {
      return {
        ...this.$listeners
      }
    },
    errorMessage () {
      if (this.errorMessages) {
        if (isArray(this.errorMessages)) {
          return head(this.errorMessages)
        }
        return this.errorMessages
      }
      return null
    },
    hasError () {
      return this.errorMessage !== null
    }
  },
  methods: {
    rerender () {
      this.rerendering = true
      this.$forceUpdate()
      // Simulate loading
      setTimeout(() => {
        this.$nextTick(() => {
          this.rerendering = false
        })
      }, 300)
    }
  },
  watch: {
    editorHeight: {
      immediate: true,
      handler (val) {
        if (val) {
          editorConfig.height = val
        }
      }
    }
  }
}
</script>

<style>
._content-editor .tox-tinymce {
  border-radius: 4px !important;
  border-color: #9e9e9e !important;
}

._content-editor .error-message {
  display: none;
}

._content-editor.editor-error .tox-tinymce {
  border-color: var(--v-error-base) !important;
  border-width: 2px;
}

._content-editor.editor-error .editor-label {
  color: var(--v-error-base);
}

._content-editor.editor-error .error-message {
  display: block;
  color: var(--v-error-base);
  font-size: 12px;
  padding-left: 10px;
  padding-top: 4px;
}
</style>
